import { configureStore } from "@reduxjs/toolkit";
import createCommitteeReducer from "../slices/createCommitteeSlice";
import adminDataReducer from "../slices/createCommitteeSlice";
import createMemberRequestReducer from "../slices/createMemberRequestSlice";
import createProfileReducer from "../slices/createProfileSlice"; // Updated import
import createRecordReducer from "../slices/createRecordSlice";
import addUserRolePermissions from "../slices/userRolePermissions";
import selectRecordsReducer from "../slices/ballotSelectRecords";
import ballotDetailsReducer from "../slices/ballotDetails";
import ballotCommitteeReducer from "../slices/ballotCommittees";
import ballotListingsReducer from "../slices/ballotListing";
import documentReducer from "../slices/documentSlice";
import toastReducer from "../slices/toastSlice";
import createStandardReducer from "../slices/createStandard";
import ballotCommentsReducer from "../slices/ballotComments";
import recordStandard from "../slices/recordStandard";
import selectedBallotDetailsReducer from "../slices/selectedBallotDetails";
import selectedApprovalCriteriaReducer from "../slices/ApprovalCriteria";
import selectedBallotConfigurationReducer from "../slices/BallotConfiguration";
import statusReducer from "../slices/statusSlice";
import setUserProfileReducer from "../slices/userProfileInfo";
import otherDataReducer from "../slices/otherDataSlices";
import draftedSlice from "../slices/draftedSlice";
import recordAdministrativeSlice from "../slices/recordAdministrative";
import recordNonStandardSlice from "../slices/nonStandardRecord";
import subjectAreaSlice from "../slices/createSubjectAreaRequest";
import createRecordReappointmentReducer from "../slices/createRecordReappointmentSlice";
import positionsData from "../slices/positionsData";
import permissionsData from "../slices/permissionsData";
const store = configureStore({
  reducer: {
    adminData: adminDataReducer,
    createCommittee: createCommitteeReducer,
    createMemberRequest: createMemberRequestReducer,
    createProfile: createProfileReducer,
    createRecord: createRecordReducer,
    ballotListingData: ballotListingsReducer,
    ballotSelectRecords: selectRecordsReducer,
    ballotDetails: ballotDetailsReducer,
    ballotCommittee: ballotCommitteeReducer,
    addUserRolePermission: addUserRolePermissions,
    document: documentReducer,
    toast: toastReducer,
    standardRequest: createStandardReducer,
    ballotCommentsData: ballotCommentsReducer,
    recordStandard: recordStandard,
    selectedBallotDetails: selectedBallotDetailsReducer,
    selectedApprovalCriteria: selectedApprovalCriteriaReducer,
    selectedBallotConfiguration: selectedBallotConfigurationReducer,
    createRecordReappointment: createRecordReappointmentReducer,
    statusData: statusReducer,
    otherData: otherDataReducer, // Added otherDataReducer
    userProfileInfo: setUserProfileReducer,
    draftedData: draftedSlice,
    recordAdministrative: recordAdministrativeSlice,
    recordNonStandard: recordNonStandardSlice,
    createSubjectAreaRequest: subjectAreaSlice,
    positionsDetails: positionsData,
    permissionsData: permissionsData,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
